import React from 'react'

export default function Loader() {
  return (
    <div className="load-bar">
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
    </div>
  )
}
